import React from 'react'
import { Accordion } from '@mc/design-system'
import type { Section } from '../types'
import { FaqQuestion } from './FaqQuestion'
import { FaqSection } from './FaqSection'

export const FaqWrapper = ({
  faqData,
  onFaqClick,
  shouldShowLargeHeader = false,
  mainTitle,
  ...props
}: {
  faqData: Section[]
  onFaqClick: (expandedIds: Array<string | number>) => void
  shouldShowLargeHeader?: boolean
  mainTitle?: string
}) => (
  <section
    {...props}
    id='faq'
    style={{ scrollMarginTop: 'var(--mc-scale-12)' }}
  >
    <h2
      className={`${
        shouldShowLargeHeader ? 'mc-text-h1' : 'mc-text-h2'
      }  mc-text--center`}
    >
      {mainTitle}
    </h2>
    <div className='row'>
      <div className='col-md-8 offset-md-2'>
        <Accordion onChange={onFaqClick}>
          {faqData.map(({ title, questions }) => (
            <FaqSection key={title} title={title}>
              {questions.map(
                ({ title: questionTitle, uuid, answer, hide }) =>
                  !hide && (
                    <FaqQuestion key={uuid} title={questionTitle} uuid={uuid}>
                      {answer}
                    </FaqQuestion>
                  ),
              )}
            </FaqSection>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
)
